import { Handle, Position } from "@xyflow/react";

export default function QueueNode(props: any) {
  return (
    <>
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
      <img src={require("../../../../../../assets/images/hardware/queue0.png")} alt="" width={300} height={100} />
        <span className="node-title">{props.data.title}</span>
    </>
  );
}
